import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-common-play",
  "use": "icon-common-play-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 17\" fill=\"none\" id=\"icon-common-play\">\n    <path d=\"M3.76562 3.56259V12.6251C3.76562 13.1701 4.29688 13.5163 4.73438 13.2551L12.4813 8.61853C12.86 8.39197 12.86 7.79572 12.4813 7.56916L4.73438 2.93259C4.29688 2.67134 3.76562 3.01759 3.76562 3.56259Z\" stroke=\"currentColor\" stroke-width=\"1.00189\" stroke-miterlimit=\"10\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol